/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {QueryRoutePageComponent} from '../report/query/query-route-page.component';

const DATA_QUERY_STATES = [
  {name: 'folder', url: '/data-queries/folder', title: 'Folder Queries', childType: 'Folder'},
  {name: 'targeting', url: '/data-queries/targeting', title: 'Targeted Advertising Queries', childType: 'UserSegment'}
];

function registerDataQueryState($stateProvider: any, config: typeof DATA_QUERY_STATES[number]): void {
  $stateProvider.state('app.data-queries.' + config.name, {
    url: config.url,
    views: {
      'content@app': {
        component: QueryRoutePageComponent
      }
    },
    data: {
      title: config.title,
      childType: config.childType,
      parentType: '',
      superParentType: '',
      useAsyncStats: false
    }
  });
}

export function dataQueriesStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider) {
    $stateProvider.state('app.data-queries', {
      url: '/data-queries',
      views: {
        'title@app': stateTitleView()
      },
      data: {
        title: 'Queries'
      }
    });

    DATA_QUERY_STATES.forEach((config) => registerDataQueryState($stateProvider, config));
  }, adnRouterHelper);
}
